import { TopSection } from '@/components/layout/layout';
import { NavItem } from '@/components/layout/nav-item';
import {
  faClockRotateLeft,
  faFilePen,
  faPenToSquare,
  faRocketLaunch
} from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import { useCampaignContext } from '@/features/campaigns/campaign-context';
import { useFlagEnabled } from '@/utils/feature-flags';
import { useStore } from '@/store/store';
import { CampaignBreadcrumbs } from '@/components/layout/breadcrumbs';

export function CampaignTopNav() {
  const { campaign } = useCampaignContext();
  const { campaign_id } = campaign;
  const activityEnabled = useFlagEnabled('activity-log-v1');
  const draftRevisions = useStore(state => state.draftRevisions);
  const hasLocalRevision = campaign_id && draftRevisions[campaign_id];

  return (
    <TopSection>
      <CampaignBreadcrumbs name={campaign.campaign_name} />
      <div className="flex-1" />
      <div className="flex items-end justify-between">
        <div className="flex items-center">
          {campaign.has_execution && (
            <NavItem
              icon={faRocketLaunch}
              to={`/campaigns/${campaign_id}/execution`}
              label="Execution Plan"
            />
          )}
          {campaign.has_execution && (campaign.has_draft_revision || hasLocalRevision) && (
            <NavItem
              icon={faPenToSquare}
              to={`/campaigns/${campaign_id}/proposal`}
              label="Draft Revision"
            />
          )}
          {!campaign.has_execution && (
            <NavItem
              icon={faFilePen}
              to={`/campaigns/${campaign_id}/proposal`}
              label="Draft Proposal"
            />
          )}
          {activityEnabled ? (
            <NavItem
              icon={faClockRotateLeft}
              to={`/campaigns/${campaign_id}/activity`}
              label="Activity"
            />
          ) : null}
          <div className="ml-10 flex items-center gap-2 rounded-md bg-gray-100 px-3 py-1">
            <span className="text-sm font-medium text-gray-600">Zoho Stage</span>
            <div className="h-4 w-px bg-gray-300" />
            <span className="text-sm text-gray-600">{campaign.stage}</span>
          </div>
        </div>
      </div>
    </TopSection>
  );
}
